import { render } from "./NewsList.vue?vue&type=template&id=8519a06a"
import script from "./NewsList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/NewsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8519a06a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8519a06a', __exports__)) {
    api.reload('8519a06a', __exports__)
  }
  
  module.hot.accept("./NewsList.vue?vue&type=template&id=8519a06a", () => {
    api.rerender('8519a06a', render)
  })

}


export default __exports__